module.exports = __webpack_public_path__ + "img/feature_buy_en.69f89129.png";